export default {"src":"/_next/static/media/male_4.cb36ad78.svg","height":144,"width":145,"blurWidth":0,"blurHeight":0};